import { render, staticRenderFns } from "./EventListTemplate.vue?vue&type=template&id=cc0dd93c"
import script from "./EventListTemplate.vue?vue&type=script&lang=js"
export * from "./EventListTemplate.vue?vue&type=script&lang=js"
import style0 from "./EventListTemplate.vue?vue&type=style&index=0&id=cc0dd93c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports